import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    cell: {
        padding: 8,
        textAlign: 'center',
    },
    cellTime: {
        padding: 8,
        letterSpacing: -1,
        textAlign: 'center',
    },
  }));
  

const formatTime = time => {
    return time.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
}

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

const transformDay = (day) => {
    switch (day) {
        case "DO":
            return "Domingo"
        case "LU":
            return "Lunes"
        case "MA":
            return "Martes"
        case "MI":
            return "Miércoles"
        case "JU":
            return "Jueves"
        case "VI":
            return "Viernes"
        case "SA":
            return "Sábado"
        default:
            return null
    }
}

export const HorariosProfesional = ({items, title}) => {
    const classes = useStyles();
    
    return ( 
        <div className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className={classes.heading}>{title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2}>
                        {/* {items.length > 0&&
                            items.map((item) => (
                                <Grid item xs={12}>
                                    <Paper>
                                        <strong>{item.idTipoParametrizacion === 2 ? 'EVENTUAL ' : 'NORMAL '}</strong>
                                        {`Dia ${item.dia} de ${formatTime(item.horaDesde)}:${formatTime(item.minDesde)} a ${formatTime(item.horaHasta)}:${formatTime(item.minHasta)}`}
                                        {` - Demanda: ${item.demanda ? 'SI' : 'NO'}`}
                                        {` - Especialidad: ${item.especialidad?.descripcionEspecialidades}`}
                                        {` - Centro Médico: ${item.centroMedico?.descripcionCentro}`}
                                        {` - Modalidad: ${item.idTipoTurno === 1 ? 'Presencial' : (item.idTipoTurno === 2 ? 'Virtual' : 'Presencial o Virtual')}`}
                                        {` - Desde: ${new Date(item.fechaInicio).toLocaleString("es", optionsfecha)}`}
                                        {` - Hasta: ${new Date(item.fechaFin).toLocaleString("es", optionsfecha)}`}
                                    </Paper>
                                </Grid>
                            ))
                        } */}
                        <TableContainer component={Paper} style={{marginLeft: 20, marginRight: 20, marginBottom: 5}}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left" style={{padding: 0}}>Tipo</TableCell>
                                        <TableCell align="left" className={classes.cell}>Modalidad</TableCell>
                                        <TableCell align="left" className={classes.cell}>Dia</TableCell>
                                        <TableCell align="left" className={classes.cell}>Centro Médico</TableCell>
                                        <TableCell align="left" className={classes.cell}>Especialidad</TableCell>
                                        <TableCell align="left" className={classes.cell}>Horario Atención</TableCell>
                                        <TableCell align="left" className={classes.cell}>Demanda</TableCell>
                                        <TableCell align="left" className={classes.cell}>Fecha Desde</TableCell>
                                        <TableCell align="left" className={classes.cell}>Fecha Hasta</TableCell>
                                        <TableCell align="left"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {items.length > 0
                                        ?
                                            items.map((item) => (
                                                <TableRow key={item.idEfHorario}>
                                                    <TableCell align="left" style={{padding: 0}}>
                                                        <strong>{item.idTipoParametrizacion === 2 ? 'EVENTUAL ' : 'NORMAL '}</strong>
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.cell}>
                                                        {item.idTipoTurno === 1 ? 'Presencial' : (item.idTipoTurno === 2 ? 'Virtual' : 'Presencial o Virtual')}
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.cell}>
                                                        {transformDay(item.dia)}
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.cell}>
                                                        {item.centroMedico?.descripcionCentro}
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.cell}>
                                                        {item.especialidad?.descripcionEspecialidades}
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.cellTime}>
                                                        {`${formatTime(item.horaDesde)} : ${formatTime(item.minDesde)} - ${formatTime(item.horaHasta)} : ${formatTime(item.minHasta)}`}
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.cell}>
                                                        {item.demanda ? `SI` : `NO`}
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.cell}>
                                                        {new Date(item.fechaInicio).toLocaleString("es", optionsfecha)}
                                                    </TableCell>
                                                    <TableCell align="left" className={classes.cell} >
                                                        {new Date(item.fechaFin).toLocaleString("es", optionsfecha)}
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        :
                                            <TableRow className={{ height: 50 }}>
                                                <TableCell colSpan={12} className={{textAlign: '-webkit-center'}}> Sin Registros</TableCell>
                                            </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            
        </div>
     );
}